module.exports = __webpack_public_path__ + "img/TiNPad-圆形-Inpillar-圆形.c8a6086b.svg";